import React, { useEffect, useState } from 'react';

import status3 from "../../assets/icons/icon-status-enviado.svg";

import * as S from './styles';
import { theme } from '../../styles/theme';
import { TaglineP } from '../../styles/stylesTypography';


const Status = ({ ...props }) => {
    return (
        <div
            style={{
                width: "auto",
                height: "auto",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
            }}
            >
            <TaglineP color={theme.colors.gray.Cinza_2}
            >
                Status
            </TaglineP>

            <S.ContainerStatus status={props.status}>
                {props.status === "AT" ? (
                    <img src={status3} alt="status" />
                ) : (
                    <div
                        style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: theme.colors.red.Vermelho_erro,
                        }}
                    />
                )}

                <TaglineP
                    fontWeight={800}
                    color={
                        props.status === "AT"
                        ? theme.colors.green.Folha
                        : theme.colors.red.Vermelho_erro
                    }
                    >
                    {props.status === "AT" ? "ATIVO" : (props.inactiveLabel ?? "INATIVO")}
                </TaglineP>
            </S.ContainerStatus>
        </div>
    );
}

export default Status;